import styled from "styled-components";

export const UploadSlot = styled.label`
  border: 1.5px dashed ${({ theme }) => theme.THEME.neonBlue};
  border-radius: 10px;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  height: ${({ theme }) => theme.CONSTANTS.XH * 40}px;
  width: ${({ theme }) => theme.CONSTANTS.XW * 78}px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.THEME.backgroundLight};
  position: relative;
  text-align: center;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
    height: ${({ theme }) => theme.CONSTANTS.XH * 40}px;
    width: ${({ theme }) => theme.CONSTANTS.XW * 20}px;
  }
`;

export const UploadLabel = styled.span`
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 1}px;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  font-family: "Sora", sans-serif;
  color: ${({ theme }) => theme.THEME.white};

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const UploadPreview = styled.img`
  width: 85%;
  height: 85%;
  object-fit: contain;
  border-radius: 8px;
  animation: fadeIn 0.4s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.96);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const UploadIcon = styled.img`
  width: 60px;
  height: 60px;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
  object-fit: contain;
`;

export const ButtonWrapper = styled.div`
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 1.5}px;
  flex-wrap: wrap;
`;

export const EditButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.THEME.neonBlue};
  border-radius: 20px;
  cursor: pointer;
  transition: 0.2s ease;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  color: ${({ theme }) => theme.THEME.white};
  width: ${({ theme }) => theme.CONSTANTS.XW * 20}px;
  height: ${({ theme }) => theme.CONSTANTS.XH * 4.5}px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:hover {
    background: ${({ theme }) => theme.THEME.neonBlue};
    color: ${({ theme }) => theme.THEME.black};
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 5}px;
    width: 140px;
    height: 44px;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.THEME.error};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 1}px;
  text-align: center;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 5}px;
  }
`;
